const HomeIcon = ({ className, stroke = "none", fill="rgb(246, 171, 11)", size = 100 }) => {
  return (
    <svg
      width={size}
      height={size * 1.5}
      viewBox="0 0 100 90"
      xmlns="http://www.w3.org/2000/svg"
      stroke={stroke}
      fill={fill}
      className={className}
    >
      <path d="M81.5,31 C82.3284271,31 83,31.6715729 83,32.5 L83,85.5 C83,85.8174101 82.9014116,86.1117936 82.7331861,86.3541992 C82.3961651,87.0183803 81.7102936,87.4496887 80.9485128,87.4496887 L18.0467687,87.4496887 C17.28116,87.4496887 16.5864685,87.0131298 16.2518589,86.3319407 C16.0926799,86.0938568 16,85.8077517 16,85.5 L16,32.5 C16,31.6715729 16.6715729,31 17.5,31 C18.3284271,31 19,31.6715729 19,32.5 L18.9997876,84.4487876 L79.9997876,84.4487876 L80,32.5 C80,31.6715729 80.6715729,31 81.5,31 Z M50.7990381,0.750000001 L97.5644099,27.75 C98.2818488,28.1642136 98.5276616,29.0815992 98.113448,29.7990381 C97.6992345,30.516477 96.7818488,30.7622898 96.0644099,30.3480762 L49.9317876,3.71278764 L3.79903811,30.3480762 C3.08159917,30.7622898 2.16421356,30.516477 1.75,29.7990381 C1.33578644,29.0815992 1.58159917,28.1642136 2.29903811,27.75 L49.0644099,0.750000001 C49.3376307,0.592255925 49.6398497,0.530235383 49.9322326,0.55353277 C50.2242899,0.530377432 50.52613,0.59243641 50.7990381,0.750000001 Z" />

      
    </svg>
  );
};

export default HomeIcon;